/**
 * Преобразует строку к числу. Если на входе null или undefined возвращает 0.
 * Принимает значение и тип преобразования
 */
export const string2Number = (value: string | null | undefined | number, type?: 'float' | 'integer'): number => {
  if (value === undefined || value === null) return 0;
  if (type === 'integer') return parseInt(value.toString());
  return parseFloat(value.toString());
};
